module.exports = __webpack_public_path__ + "assets/58a24fb20d92e9726fe55e0271bd995d.png";